import type { CityInfo, CountryInfo, RegionInfo } from '@/shared/api/experience';
import { useTourFiltersStore } from '@/entities/filter/store/tour';

export const useTourSoguStore = defineStore('tour-sogu', () => {
  const filterStore = useTourFiltersStore();

  const geoObject = ref<CityInfo | CountryInfo | RegionInfo>({});
  const rubricId = ref<number | null>(null);

  const setGeoObject = (geo: MaybeRefOrGetter<CityInfo | CountryInfo | RegionInfo>) => {
    geoObject.value = toValue(geo);
  };

  const totalExperiences = computed(() => {
    return geoObject.value.tours_count || 0;
  });

  const filteredExperiences = computed(() => {
    return filterStore.searchTotalCount || 0;
  });

  return {
    rubricId,
    setGeoObject,
    totalExperiences,
    filteredExperiences,
  };
});
